// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gameCard-wrapper .game-card .ant-card-body {
  padding: 20px 6px;
}
.gameCard-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-start;
  margin: 0 auto;
  max-width: calc((320px * 5) + (16px * 4));
}
@media (max-width: 1087px) {
  .gameCard-wrapper {
    max-width: calc((320px * 3) + (16px * 2));
  }
  .gameCard-wrapper .game-card {
    width: 208px;
  }
}
@media (max-width: 767px) {
  .gameCard-wrapper {
    max-width: 100%;
    justify-content: center;
  }
  .gameCard-wrapper .game-card {
    flex: 0 0 100%;
    width: 320px;
  }
}
.game-card.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.game-card.disabled .play-button {
  display: none;
}
.game-card {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  flex: 0 0 auto;
  min-width: 160px;
  max-width: 320px;
  width: 186px;
  border: none;
  box-shadow: 0px 8px 32px 0px #34383F14;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.game-card .card-cover-wrapper {
  display: flex;
  flex-direction: column;
  transition: all 0.25s ease;
}
.game-card .card-cover-wrapper .card-image {
  width: 100%;
  height: 160px;
  object-fit: cover;
  display: block;
  transition: filter 0.25s ease;
}
.game-card .game-title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.game-card .card-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.54);
  opacity: 0;
  transition: opacity 0.25s ease;
  z-index: 1;
  height: 160px;
}
.game-card .play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
.game-card:not(.disabled):hover .card-overlay {
  opacity: 1;
}
.game-cover-image-container {
  position: relative;
  width: 100%;
  height: 160px;
  overflow: hidden;
}
.game-cover-image-container .game-cover-image-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
